import './App.css';
import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LegacyRedirect from './LegacyRedirect';
import LEGACY_ROUTES from './legacyRoutes.json';

// Every route is code-split: visiting the story used to download the survey engine
// and all the other dashboards too, in one ~780KB (gzipped) bundle. Each route
// now pulls only its own chunk, so the first paint of any page is much lighter.
const SurveyComponent = lazy(() => import('./getsurvey/Survey'));
const YouthDashboard = lazy(() => import('./dashboards/YouthDashboard'));
const FuturesDashboard = lazy(() => import('./dashboards/FuturesDashboard'));
const VisionsDashboard = lazy(() => import('./dashboards/VisionsDashboard'));
const RelishExplorerDashboard = lazy(() => import('./dashboards/RelishExplorerDashboard'));
const RelishScrollStory = lazy(() => import('./dashboards/RelishScrollStory'));
const RelishScrollStory2 = lazy(() => import('./dashboards/RelishScrollStory2'));
const RelishScrollStory3 = lazy(() => import('./dashboards/story3'));
const StoryInteractionsDashboard = lazy(() => import('./dashboards/StoryInteractionsDashboard'));
const FoodTinder = lazy(() => import('./dashboards/FoodTinder'));
const EvalGate = lazy(() => import('./eval/EvalGate'));
const ExpertGate = lazy(() => import('./eval/ExpertGate'));

// Neutral placeholder: each page paints its own richer loading state once its
// chunk arrives, so this only ever shows for the moment the chunk is in flight.
const RouteFallback = () => (
  <div style={{ minHeight: '100vh', background: '#FFF9F0', display: 'flex',
    alignItems: 'center', justifyContent: 'center' }}>
    <div style={{ fontSize: 38, animation: 'app-route-spin 1.6s linear infinite' }}>🍳</div>
    <style>{'@keyframes app-route-spin { to { transform: rotate(360deg); } }'}</style>
  </div>
);

function App() {
  return (
    <div className="App">
      <Router basename="/">
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            {/* Official public addresses */}
            <Route path="/the_borrowed_plate" element={<RelishScrollStory3 />} />
            <Route path="/food_visions_2050" element={<FoodTinder />} />
            <Route path="/dashboard_youth_food_culture" element={<YouthDashboard title="Youth Dashboard" />} />
            <Route path="/dashboard_future_perspectives" element={<FuturesDashboard title="Futures Dashboard" />} />
            <Route path="/dashboard_food_visions_2050" element={<VisionsDashboard title="Futures Narratives Dashboard" />} />
            <Route path="/survey_youth_food_culture" element={<SurveyComponent title="Youth Survey" />} />
            <Route path="/survey_future_perspectives" element={<SurveyComponent title="Futures Survey" />} />
            <Route path="/survey_food_visions_2050" element={<SurveyComponent title="Futures Narratives" />} />

            {/* Old public addresses → new ones (query string and #fragment kept) */}
            {Object.entries(LEGACY_ROUTES).map(([from, to]) => (
              <Route key={from} path={from} element={<LegacyRedirect to={to} />} />
            ))}

            {/* Unchanged: Prolific links (configured on Prolific), evaluation, archive */}
            <Route path="/youth_survey_prolific" element={<SurveyComponent title="Youth Survey Prolific" />} />
            <Route path="/futures_survey_prolific" element={<SurveyComponent title="Futures Survey Prolific" />} />
            <Route path="/futures_narratives_prolific" element={<SurveyComponent title="Futures Narratives Prolific" />} />
            <Route path="/explorer" element={<RelishExplorerDashboard />} />
            <Route path="/story_dashboard" element={<StoryInteractionsDashboard />} />
            <Route path="/story1" element={<RelishScrollStory />} />
            <Route path="/story2" element={<RelishScrollStory2 />} />
            <Route path="/story3" element={<LegacyRedirect to="/the_borrowed_plate" />} />
            <Route path="/tinder" element={<LegacyRedirect to="/food_visions_2050" />} />
            <Route path="/futures_radar" element={<LegacyRedirect to="/food_visions_2050" />} />
            <Route path="/eval_youth" element={<EvalGate pair="youth" />} />
            <Route path="/eval_futures" element={<EvalGate pair="futures" />} />
            <Route path="/eval_survey" element={<SurveyComponent title="RELISH Evaluation" />} />
            <Route path="/eval_expert" element={<ExpertGate />} />
            <Route path="/expert_survey" element={<SurveyComponent title="RELISH Evaluation — Expert" />} />
          </Routes>
        </Suspense>
      </Router>
    </div>
  );
}

export default App;
